(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nxt-stackCourse-section"] && !Shopify.designMode) return;
  try {
    
  function initCourseRatings() {
    const courseRatings = document.querySelectorAll('.course-rating-card__rh');

    courseRatings.forEach((courseContainer) => {
      renderCourseStars(courseContainer);
    });
  }

  function renderCourseStars(courseContainer) {
    let courseValue = parseFloat(courseContainer.dataset.rating) || 0;

    // If value is > 5, treat as percentage and convert to 0-5 scale
    if (courseValue > 5) {
      courseValue = (courseValue / 100) * 5;
    }

    // Clamp between 0 and 5
    courseValue = Math.max(0, Math.min(5, courseValue));

    // Clear container
    courseContainer.innerHTML = '';

    // Create 5 stars
    for (let j = 1; j <= 5; j++) {
      const courseStar = document.createElement('span');
      courseStar.className = 'star__rh';

      if (courseValue >= j) {
        // Full star
        courseStar.classList.add('star-full__rh');
        courseStar.innerHTML = '★';
      } else if (courseValue > j - 1) {
        // Partial star - calculate fill percentage
        const courseFillPercent = (courseValue - (j - 1)) * 100;
        courseStar.classList.add('star-partial__rh');
        courseStar.innerHTML = `
                        <span class="star-bg__rh">★</span>
                        <span class="star-fill__rh" style="width: ${courseFillPercent}%">★</span>
                    `;
      } else {
        // Empty star
        courseStar.classList.add('star-empty__rh');
        courseStar.innerHTML = '★';
      }

      courseContainer.appendChild(courseStar);
    }
  }

  // Function to update course rating dynamically
  function updateCourseRating(courseContainer, newCourseRating) {
    courseContainer.dataset.rating = newCourseRating;
    renderCourseStars(courseContainer);
  }

  // Initialize course ratings on DOM load
  document.addEventListener('DOMContentLoaded', initCourseRatings);

  // Sticky card active class detection
  function initStickyCards() {
    const stickyCards = document.querySelectorAll('[data-sticky-card]');

    if (!stickyCards.length) return;

    // Set first card as active initially
    stickyCards[0].classList.add('active');

    function updateActiveCard() {
      let activeIndex = 0;
      const cardsArray = Array.from(stickyCards);

      // Find the last card that has reached its sticky position
      cardsArray.forEach((card, index) => {
        const cardTop = parseInt(card.style.top) || 40;
        const rect = card.getBoundingClientRect();

        // Card is at or past its sticky position
        if (rect.top <= cardTop + 5) {
          activeIndex = index;
        }
      });

      // Remove active from all cards and add to the current one
      cardsArray.forEach((card, index) => {
        if (index === activeIndex) {
          card.classList.add('active');
        } else {
          card.classList.remove('active');
        }
      });
    }

    // Check on scroll
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateActiveCard();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Initial check
    updateActiveCard();
  }

  document.addEventListener('DOMContentLoaded', initStickyCards);

  } catch(e) { console.error(e); }
})();
})();
